import { Injectable } from '@angular/core';

import { ClientService, httpHeaders } from '../../client.service';

import { EventsQueryParams } from './activity-feed.model';

@Injectable()
export class ActivityFeedApi {
  constructor(private clientService: ClientService) {}

  /**
   * Returns list of events for Event Log
   * @param params
   * @deprecated since version 2.81.0, use EventHistoryApi
   */
  getEvents(params: EventsQueryParams): any {
    const endpoint = `activity-feed/v2/events`;

    return this.clientService.get(endpoint, params, httpHeaders);
  }
}
